import {IRouteDefinition, TRouteId} from "../../../index";
import {getRouteDefinition} from "../../../constants/RouteDefinitions";

type TMenuOption = TRouteId | TRouteId[]

export interface IMenuGroup {
    groupLabel: string
    groupIcon: string
    items: TMenuOption[]
}

export const MenuGroups: IMenuGroup[] = [
    {
        groupLabel: 'nav-left.section.myprofile.heading',
        groupIcon: 'fa-user',
        items: [],
    },
    {
        groupLabel: 'nav-left.section.users-org.heading',
        groupIcon: 'fa-users',
        items: ['userstart', 'departmentstart', 'legalunitstart', 'groupstart'],
    },
    {
        groupLabel: 'nav-left.section.accessmanagement.heading',
        groupIcon: 'fa-lock',
        items: ['systemaccesstart', 'wizardpermissions'],
    },
    {
        groupLabel: 'nav-left.section.automation.heading',
        groupIcon: 'fa-sync-alt',
        items: ['sync', 'rulesetsearch', 'messageflowsearch', ['ehub', 'formdatasearch'], 'apiuserstart'],
    },
    {
        groupLabel: 'nav-left.section.sysadmin.heading',
        groupIcon: 'fa-cog',
        items: [
            'logstart',
            'systemfieldsdetails',
            'customerconfig',
            'report',
        ],
    },
    {
        groupLabel: 'nav-left.section.eadm.heading',
        groupIcon: 'fa-puzzle-piece-info',
        items: ['about_privacypolicy', 'about_application', 'sitemap'],
    },
];

const menuRouteIds: TMenuOption[] = MenuGroups.flatMap(g => g.items);

export const Menu: (IRouteDefinition | IRouteDefinition[])[] = menuRouteIds.map((opt: TMenuOption): (IRouteDefinition | IRouteDefinition[]) => {
    if (Array.isArray(opt)) {
        return opt.map(o => getRouteDefinition(o)).filter((d): d is IRouteDefinition => d != null)
    }
    return getRouteDefinition(opt)!
});
